// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"b9010334","537":"c06b41b2","891":"324c2b79"}[chunkId] + ".chunk.css";
};